import { createAction, props, union } from '@ngrx/store'
import { Task } from './task.model'
import { TaskForm } from '@tv3/interfaces/forms/task.form'
import { Update } from '@ngrx/entity'
import { TaskRequest } from '@tv3/interfaces/requests/task-request'

export const LoadTasks = createAction('[Task] Load Tasks')
export const LoadTasksComplete = createAction('[Task] Load Tasks Complete', props<{ tasks: Task[] }>())

export const AddTask = createAction('[Task] Add Task', props<{ form: TaskForm }>())
export const AddTaskComplete = createAction('[Task] Add Task Complete', props<{ task: Task }>())

export const AddTasks = createAction('[Task] Add Tasks', props<{ requests: TaskRequest[] }>())
export const AddTasksComplete = createAction('[Task] Add Tasks Complete', props<{ tasks: Task[] }>())

export const DeleteTask = createAction('[Task] Delete Task', props<{ id: string }>())
export const DeleteTaskComplete = createAction('[Task] Delete Task Complete', props<{ id: string }>())

export const UpdateTask = createAction('[Task] Update Task', props<{ form: TaskForm; task: Task }>())
export const UpdateTaskComplete = createAction('[Task] Update Task Complete', props<{ update: Update<Task> }>())

export const ChangeTaskStatus = createAction('[Task] Change Status', props<{ status: number; task: Task }>())
export const ChangeTaskStatusComplete = createAction('[Task] Change Status Complete', props<{ update: Update<Task> }>())
